import filesReducer from './reducers';
export { default as filesOperations } from './operations';
export { default as filesTypes } from './types';
export default filesReducer;
